import styled from 'styled-components';
import { IC_OFF_BOX, IC_OFF_BOX_LEFT, IC_RIGHT_PAGINATION_ARROW_GREEN, IMG_1ASTER_EXCLUSIVE } from '@common/Assets/images';

export default styled.div`
  .ic-express {
    position: absolute;
    top: 40px;
    left: 0;
  }

  .Bundle_deal_pdp {
    margin-top: 4px;
    display: flex;
    justify-content: space-between;
    .starRating {
      margin-left: auto;
    }
  }

  .ic-express-top {
    position: absolute;
    top: 14px;
    left: 0;
  }

  .richMediaWrapper {
    width: 100%;
    max-width: 400px;
    margin: 0 auto 16px auto;
    display: flex;
    justify-content: center;
    align-items: center;

    > div {
      width: 100%;
    }
  }

  .mediaImage {
    width: auto;
    height: auto;
    max-width: 100%;
  }

  .btnRefund {
    width: 86%;
    border-radius: 5px;
    margin-bottom: 16px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;

    .ic {
      display: flex;
      align-items: center;
      margin-right: 15px;
      margin-left: 15px;
      position: relative;
    }

    .text {
      color: ${(props) => props?.theme?.green?.darkGreen};
      font-size: 16px;
      font-weight: 600;
      text-align: left;
    }

    .arrow {
      width: 24px;
      height: 24px;
      display: flex;
      position: relative;
      margin: 0 2px;
    }

    &.notRefundable {
      .text {
        color: ${(props) => props?.theme?.colors?.neutral?.darkBlue?.['400']};
      }
      .arrow {
        margin-left: 4px;
      }
    }
  }

  .specificationsBox {
    margin-bottom: 16px;

    .specs {
      width: 100%;
      padding: 24px;
      display: flex;
      flex-direction: column;

      .specRow {
        width: 100%;
        margin-bottom: 20px;
        display: flex;
        flex-direction: row;

        .labelText {
          min-width: 150px;
          max-width: 150px;
          font-size: 14px;
          font-weight: 600;
        }

        .valueText {
          color: ${(props) => props?.theme?.text?.medium};
          font-size: 14px;
          font-weight: 400;
        }

        &:last-child {
          margin-bottom: 0%;
        }
      }
    }
  }

  .legalDisclaimerClick {
    width: 100%;
    padding: 24px;
    border-top: 1px solid ${(props) => props?.theme?.color?.border};
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;

    .ic {
      width: 100%;
      max-width: 25px;
      max-height: 25px;
      margin-right: 12px;
      margin-left: 12px;
      display: flex;
    }

    .text {
      color: ${(props) => props.theme.green.dark};
      font-size: 15px;
      font-weight: 700;
    }
  }

  .pom-wrapper{
    align-items: center;
    width: auto;
    margin: 0px 0px 16px 0px;
    gap: 3px;
    border-radius: 6px;
    border: 1px solid ${(props) => props.theme.colors.accent.gold['50']};
    background: ${(props) => props.theme.colors.accent.gold['25']};

    .rx-container {
      display: flex;
      align-items: center;
    }

    .mounjaro-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 12px 8px 12px;
      background-color: ${(props) => props.theme.color.smokeWhite};
    }

    .no-prescription-header {
      font-family: Mulish;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: 16px;
    }

    .no-prescription-description {
      font-family: Mulish;
      font-size: 10.5px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px;
    }

    .consult-now-container {
      font-family: Mulish;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: 16px;
      padding: 12px;
      border-radius: 4px;
    }

    .pom-img{
      padding-left: 12px;
      margin-top: 5px;
    }

    .pom-text{
      color: ${(props) => props.theme.colors.accent.gold['900']};
      font-size: 15px;
      font-weight: 500;
      line-height: 20px;
      text-align: left;
      padding-top: 1px;
    }
  }

  .disclaimer-scheduled-wrapper{
    display: flex;
    align-items: center;
    width: auto;
    height: 46px;
    margin: 0px 0px 24px 0px;
    gap: 3px;
    border-radius: 0px 0px 8px 8px;
    background: ${(props) => props?.theme?.colors?.accent?.yellow['25']};
    border: 1px solid ${(props) => props?.theme?.colors?.neutral?.darkBlue?.['50']};
    border-top: none;

    .diclaimer-img{
      padding-left: 13px;
      margin-top: 7px;
    }

    .disclaimer-scheduled-text{
      font-size: 13px;
      font-weight: 600;
      line-height: 20px;
      text-align: left;
      padding-top: 2px;
    }
  }

  .videoWrapperRichMedia {
    cursor: pointer;
    position: relative;
    margin: auto;
    width: 50%;
    text-align: center;

    div:nth-child(2) {
      position: absolute !important;
      right: 40%; 
      top: 40%;

      @media (max-width: 480px) {
        right: 32%;
        top: 35%;

        img {
          width: 50px;
        }
      }
    }
  }

  .showSpecs {
    color: ${(props) => props.theme.green.dark};
    font-size: 16px;
    font-weight: 700;
    line-height: 18px;
    margin-bottom: 24px;
    cursor: pointer;
  }

  .productDetailWrapper {
    width: 100%;
    margin: 0 0 30px 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .productShowCase {
      width: 100%;
      min-width: 50%;
      padding-right: 16px;
      padding-left: 16px;
      position: sticky;
      z-index: 1;
      top: 100px;
      bottom: 0;

      .videoWrapper {
        cursor: pointer;
        position: relative;

        div:nth-child(2) {
          position: absolute !important;
          right: 40% !important;
          top: 40% !important;
        }
      }
    }

    .badgeStack {
      position: absolute;
      top: 0;
      left: 0;
      padding: 15px 0 0 15px;
      z-index: 1;
    }

    .exclusive-tost {
      position: absolute;
      top: 14px;
      left: 0;
      width: 150px;
      height: 25px;
      background-image: url(${IMG_1ASTER_EXCLUSIVE.src}) !important;
      background-repeat: no-repeat;
      font-weight: 700;
      font-size: 11.8031px;
      line-height: 25px;
      text-transform: uppercase;
      color: ${(props) => props.theme.color.white};
      text-align: left;
      padding-left: 10px;
    }

    .productCarousalWrapper {
      width: 100%;

      .slick-slider {
        position: relative;

        .slick-list {
          width: calc(100% - 120px);
          height: 77px;
          margin: 0 60px;

          .slick-track {
            margin-top: 5px;
          }
        }
        .slick-arrow {
          &.slick-prev {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 0;
            width: 32px;
            height: 77px;
            background: ${(props) => props.theme.color.white};
            box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.04);
            border-radius: 8px 0 0 8px;
          }

          &.slick-next {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 0;
            width: 32px;
            height: 77px;
            background: ${(props) => props.theme.color.white};
            box-shadow: 0 3px 6px rgba(0, 0, 0, 0.04);
            border-radius: 0 8px 8px 0;
          }
        }
      }

      .item-wrapper {
        width: 64px;
        min-width: 64px;
        height: 68px;
        background-color: ${(props) => props.theme.color.white};
        border: 1px solid ${(props) => props.theme.color.lightGray};
        box-sizing: border-box;
        margin: 0 16px 0 0;
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
          border: 1px solid ${(props) => props?.theme?.green?.dark};
        }

        &.active {
          border: 1px solid ${(props) => props?.theme?.green?.dark};
        }

        .product-thumb {
          width: 65px;
          min-width: 65px;
          height: 65px;
          position: relative;
          display: flex;

          .videoThumb {
            position: absolute !important;
            right: 30% !important;
            top: 32% !important;
          }

          img {
            width: 100%;
            height: auto;
          }
        }
      }
    }

    .productShowcaseWrapper {
      width: 100%;
      max-width: 548px;
      min-height: 430px;
      background-color: ${(props) => props.theme.color.white};
      border: 1px solid ${(props) => props.theme.color.lightGray};
      margin: 0 0 15px 0;
      padding: 5px;
      border-radius: 8px;
      position: relative;
      text-align: center;
      box-sizing: border-box;
      display: block;
      align-items: center;
      justify-content: center;
      z-index: 999;

      .productShowcase {
        min-height: 410px;
        max-width: 420px;
        max-height: 420px;
        margin: 0 auto;
        display: flex;
        justify-content: center;

        > div {
          display: flex;
        }

        img {
          width: 100%;
          height: 100%;
        }
      }

      .offer-tost {
        width: 80px;
        height: 24px;
        color: ${(props) => props?.theme?.color?.white};
        font-weight: 700;
        background: url(${IC_OFF_BOX.src}) no-repeat 100% 50% / cover;
        display: flex;
        align-items: center;
        padding-left: 6px;
        margin-bottom: 8px;

        span {
          margin-left: 3px;
          font-size: 11px;
        }
      }

      .addToWishList {
        width: 40px;
        height: 40px;
        border-radius: 20px;
        position: absolute;
        background: ${(props) => props.theme.color.white};
        box-shadow: 0 3px 7px rgba(33, 57, 79, 0.08);
        top: 23px;
        right: 23px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        img {
          border-radius: 0;
        }
      }

      .share-tost {
        width: 40px;
        height: 40px;
        border-radius: 20px;
        position: absolute;
        background: ${(props) => props.theme.color.white};
        box-shadow: 0 3px 7px rgba(33, 57, 79, 0.08);
        top: 79px;
        right: 23px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .filter {
          width: 18px;
          height: 20px;

          .ic {
            width: 18px;
            height: 20px;
          }

          .display-none {
            display: none;
          }

          .filterBox {
            min-width: 198px;
            text-align: left;
            background: ${(props) => props?.theme?.color?.white};
            border: 1px solid ${(props) => props?.theme?.color?.borderLight};
            padding: 16px 14px;
            position: absolute;
            top: calc(100% + 10px);
            right: -10px;
            border-radius: 4px;
            z-index: 2;

            .box {
              margin: 0 0 16px 0;

              .title {
                font-size: 15px;
                font-weight: 600;

                .react-share__ShareButton {
                  width: 100%;
                  display: flex;
                  flex-direction: row;
                  align-items: center;

                  > div {
                    width: 36px;
                    height: 36px;
                    margin-right: 10px !important;
                    position: relative;
                  }
                }
              }

              &:last-child {
                margin: 0;
              }
            }

            &.openUp {
              top: auto;
              bottom: calc(100% + 20px);

              &::before {
                top: auto;
                bottom: -9px;
                transform: rotate(180deg);
              }

              &::after {
                top: auto;
                bottom: -8px;
                transform: rotate(180deg);
              }
            }

            &:before,
            &:after {
              content: '';
              width: 12px;
              height: 8px;
              position: absolute;
              border-top: 0;
            }
            &:after {
              top: -8px;
              right: 20px;
              border-bottom: 8px solid ${(props) => props.theme.color.white};
              border-right: 8px solid transparent;
              border-left: 8px solid transparent;
            }
            &:before {
              top: -10px;
              right: 19px;
              border-bottom: 9px solid ${(props) => props.theme.color.border};
              border-right: 9px solid transparent;
              border-left: 9px solid transparent;
            }
          }
        }
      }

      .slick-dots {
        li.slick-active {
          button {
            background: ${(props) => props.theme.green.dark};
          }
        }
      }

      .extraInfoForMobile {
        width: 100%;
        height: 100%;
        background-image: linear-gradient(
          89.97deg,
          ${(props) => props?.theme?.color?.black}CC 0.02%,
          ${(props) => props?.theme?.color?.black}4D 99.98%
        );
        border-radius: 8px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;

        .infoInside {
          width: 150px;
          padding: 24px 16px;
          color: ${(props) => props?.theme?.color?.white};
          text-align: left;

          .keyTitle {
            font-size: 20px;
            line-height: 28px;
            margin-bottom: 16px;
            font-weight: 700;
          }

          .extraInfoRow {
            position: relative;
            padding-bottom: 10px;
            margin-bottom: 10px;

            .extraInfoLabel {
              color: ${(props) => props?.theme?.blue?.grey};
              font-size: 12px;
              font-weight: 500;
            }

            .extraInfoValue {
              color: ${(props) => props?.theme?.color?.white};
              font-size: 15px;
              font-weight: 700;
            }

            &::after {
              width: 100%;
              height: 1px;
              content: '';
              background-image: linear-gradient(
                89.97deg,
                ${(props) => props?.theme?.color?.white}80 30%,
                ${(props) => props?.theme?.color?.white}00 100%
              );
              position: absolute;
              bottom: 0;
              left: 0;
            }

            &:last-child {
              &::after {
                width: 0;
                height: 0;
                padding-bottom: 0%;
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }

    .productInfoWrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
    }

    .uspBox {
      width: 86%;
      border-radius: 8px;
      border: 1px solid ${(props) => props?.theme?.color?.borderLight};
      background: ${(props) => props?.theme?.color?.white};
      padding: 20px 16px 16px 16px;
      margin-bottom: 16px;
      display: flex;
      flex-direction: row;

      .usp {
        width: 33%;
        margin: 0 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .ic {
          width: 100%;
          max-width: 52px;
          max-height: 32px;
          margin-bottom: 16px;
          display: flex;
          opacity: 0.7;
          img {
            display: flex;
          }
        }

        .name {
          color: ${(props) => props?.theme?.text?.medium};
          text-align: center;
          font-size: 14px;
          font-weight: 600;
        }

        &:first-child {
          margin-left: 0;
          .name {
            max-width: 150px !important;
          }
        }

        &:last-child {
          margin-right: 0;
          .name {
            max-width: 150px !important;
          }
        }
      }
    }

    .bankOffersBox {
      width: 86%;
      border-radius: 8px;
      border: 2px dashed ${(props) => props?.theme?.color?.borderLight};
      background: ${(props) => props?.theme?.color?.white};
      padding: 16px;
      margin-bottom: 16px;

      .offersBox {
        width: 100%;
        padding-bottom: 16px;
        display: flex;

        .ic {
          width: 23px;
          height: 23px;
        }

        .description {
          width: 100%;
          margin-left: 12px;
          margin-right: 12px;

          strong {
            color: ${(props) => props?.theme?.color?.black};
            font-weight: 700;
            margin-right: 5px;
          }

          .text {
            color: ${(props) => props?.theme?.text?.medium};
            font-size: 13px;
            font-weight: 600;
          }

          .showHide {
            color: ${(props) => props?.theme?.green?.dark};
            font-size: 14px;
            font-weight: 600;
            margin-top: 4px;
            cursor: pointer;
          }
        }
      }
      .moreOffers {
        color: ${(props) => props?.theme?.green?.dark};
        font-size: 14px;
        font-weight: 700;
        padding-top: 16px;
        border-top: 1px solid ${(props) => props?.theme?.color?.borderLight};
        cursor: pointer;
      }
    }
    .productDetailInfo {
      width: 86%;
      min-width: 50%;
      background: ${(props) => props?.theme?.color?.white};
      border: 1px solid ${(props) => props?.theme?.color?.borderLight};
      padding: 16px;
      margin-bottom: 16px;
      border-radius: 8px;
      display: flex;
      flex-direction: column;

      .brandNameProductNameOuter {
        width: 100%;
        border-bottom: 1px solid ${(props) => props.theme.color.lightGray};
        margin-bottom: 12px;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        .starRating {
          cursor: pointer;
        }
      }

      .brandNameProductNameInner {
        width: 100%;
        padding-right: 5px;
      }

      .brandName {
        color: ${(props) => props.theme.green.dark};
        font-size: 14px;
        font-weight: 700;
        line-height: 18px;
        margin: 0 0 4px 0;

        a {
          color: ${(props) => props.theme.green.dark};
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      .productName {
        color: ${(props) => props.theme.text.dark};
        font-size: 20px;
        line-height: 25px;
        font-weight: 700;
        padding-bottom: 12px;
      }

      .tempOOS {
        color: ${(props) => props?.theme?.colors?.secondary?.orange?.["700"]};
        padding: 15px 0px;
        text-align: right;
      }

      .delivery-flash {
        background: ${(props) => props?.theme?.colors?.accent?.yellow?.["25"]} !important;
      }

      .delivery-image-and-text {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
      }

      .delivery-detail {
        width: 100%;
        background: ${(props) => (!props.isScheduled ? props?.theme?.grey?.greyF4 : props?.theme?.colors?.neutral?.darkBlue?.['25'])};
        box-sizing: border-box;
        border: 1px solid ${(props) => props?.theme?.grey?.iconBg};
        padding: 12px;
        margin-bottom: ${(props) => ( props.scheduledDeliveryMessage ? '0px' : '15px')};
        border-radius: ${(props) => (props.scheduledDeliveryMessage ? '8px 8px 0px 0px' : '8px')};
        border-bottom: ${(props) => (props.scheduledDeliveryMessage ? 'none' : '')};
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .icFlash {
          width: 50px;
          height: 22px;
          position: relative;
          margin-right: 10px;        
        }

        .icPomProduct {
          width: 27px;
          height: 24px;
          position: relative;
          margin-right: 10px;
        }
        
        .icExpressSheduled {
          width: 74px;
          height: 22px;
          position: relative;
          margin-right: 10px;
          margin-left: 10px;
        }

        .icExpress {
          width: 74px;
          height: 22px;
          position: relative;
          margin-right: 10px;
          margin-left: 10px;
        }

        .ic-delivery {
          width: 26px;
          height: 15px;
          position: relative;
          margin-right: 10px;
          margin-top: 5px;
        }

        .delivery-time {
          color: ${(props) => props?.theme?.text?.dark};
          font-weight: 600;
          font-size: 15px;
          line-height: 19px;

          strong {
            color: ${(props) => props.theme.text.dark};
            font-weight: 700;
          }

          span {
            font-weight: 400;
            font-size: 14px;
            line-height: 18px;
            margin-top: 2px;
            color: ${(props) => props.theme.text.dark};
          }

          .duration {
            background: ${(props) => props.theme.green.medium};
            font-size: 14px;
            font-weight: 700;
            border-radius: 4px;
            padding: 1px 4px;
            margin-left: 2px;
            margin-right: 5px;
            display: inline-flex;
          }

          .flash-duration {
            background: ${(props) => props?.theme?.color?.ratingAlpha};
          }

          .orderWithin {
            color: ${(props) => props?.theme?.text?.grey};
            font-weight: 600;
          }
        }
      }
      .info {
          width: 20px;
          height: 20px;
          cursor: pointer;
        }
      .bundle-offer {
        width: 100%;
      }
      .priceContainer {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 8px;

        .points-wrapper {
          background-color: ${(props) => props.theme.color.white};
          min-width: 105px;
          height: 36px;
          border: 1px solid ${(props) => props.theme.color.divider};
          box-sizing: border-box;
          border-radius: 6px;
          padding: 5px;
          display: flex;
          font-weight: 700;
          font-size: 16px;
          line-height: 20px;
          text-align: right;
          margin-top: 10px;
          color: ${(props) => props.theme.mandalay.dark};

          span {
            color: ${(props) => props.theme.text.medium};
            font-size: 14px;
          }

          .ic-point-heart {
            width: 14px;
            display: flex;
          }
        }

        .priceWrapper {
          .price {
            font-weight: 700;
            font-size: 22px !important;
            line-height: 28px;
            color: ${(props) => props.theme.text.dark};
            margin-bottom: 4px;
            display: flex;
            gap: 6px;
            align-items: center;
            direction: ltr;

            span {
              font-weight: 600;
              font-size: 15px;
              line-height: 19px;
              text-decoration-line: line-through;
              color: ${(props) => props.theme.text.medium};
              display: flex;
            }
          }
          .tax {
            font-weight: 600;
            font-size: 13px;
            line-height: 16px;
            color: ${(props) => props?.theme?.colors?.neutral?.darkBlue?.['400']};
            
          }
        }
      }
      .lowest-price-and-stock{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        .lowest-price {
          display: flex;
          padding: 6px 8px;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          border-radius: 6px;
          background: ${(props) => props?.theme?.colors?.secondary?.red["50"]};
          color: ${(props) => props?.theme?.color?.red};
          font-family: Mulish;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          text-transform: capitalize;
        }
      }
      .stock {
        color: ${(props) => props?.theme?.colors?.secondary?.orange?.['700']};
        font-size: 13px;
        line-height: 16px;
        font-weight: 700;
        margin-left: auto;
      }

      .discountEnds {
        width: 100%;
        border-radius: 100px;
        background: linear-gradient(90deg, #FDF1F0 0%, #FFF 100%);
        margin-bottom: 12px;
        padding: 4px 8px;
        border-radius: 8px;
        display: flex;
        align-items: center;

        > div {
          margin-right: 6px !important;
        }

        .discLabel {
          color: ${(props) => props?.theme?.text?.darkest};
          font-size: 14px;
          font-weight: 600;
          margin-right: 6px;
          line-height: 20px;
        }

        .timer {
          color: ${(props) => props?.theme?.color?.red};
          font-size: 14px;
          font-weight: 700;
          letter-spacing: 1px;
          line-height: 20px;
        }
      }

      .order-wrapper {
        display: flex;

        .btn-outline-success,
        .btn-success {
          height: 52px;
        }

        .addToCartButtonWrapper {
          width: 100%;
          display: flex;

          .quantity-wrapper-small {
            width: 109px;
            padding: 0;
            margin-bottom: 0;
          }

          .isFloat {
            width: 100%;
            padding-left: 12px;
          }

          .btn-outline-success,
          .btn-outline-danger,
          .btn-success {
            width: 100%;
          }
        }
      }
      .quantity-wrapper {
        position: relative;
        .txtLoading {
          .dropdown-wrapper {
            &.dropdown {
              .dropdown-toggle {
                padding: 12px 35px 13px 35px;
                font-size: 15px;

                &:after {
                  display: none;
                }
              }
            }
          }
        }
        .dropdown-wrapper {
          &.dropdown {
            .dropdown-toggle {
              height: 52px;
              text-align: center;
              font-weight: 700;
              font-size: 20px;
              line-height: 25px;
              color: ${(props) => props.theme.green.dark};
              border: 1px solid ${(props) => props?.theme?.colors?.neutral?.darkBlue?.['50']};
              border-radius: 100px;
              &:after {
                right: 39% !important;
              }
            }
            .dropdown-menu {
              &.show {
                a {
                  text-align: center;
                  display: block;
                  font-weight: 600;
                  font-size: 16px;
                  line-height: 20px;
                  color: ${(props) => props.theme.text.dark};
                }
              }
            }
          }
        }
        .decrease-product {
          position: absolute;
          top: 6px;
          left: 5px;
          width: 40px;
          height: 40px;
          cursor: pointer;
        }
        .increase_product {
          position: absolute;
          top: 6px;
          right: 5px;
          width: 40px;
          height: 40px;
          cursor: pointer;
        }
      }
      .quantity-wrapper-small {
        position: relative;
        margin-bottom: 15px;
        .dropdown-wrapper {
          &.dropdown {
            .dropdown-toggle {
              text-align: center;
              font-weight: 700;
              font-size: 20px;
              line-height: 25px;
              color: ${(props) => props.theme.green.dark};
              border: 1px solid ${(props) => props.theme.green.dark};

              &:after {
                right: 25% !important;
              }
            }
            .dropdown-menu {
              z-index: 1;
              max-height: 271px;
              overflow: auto;
              width: 103px;
              &.show {
                a {
                  text-align: center;
                  display: block;
                  font-weight: 600;
                  font-size: 16px;
                  line-height: 20px;
                  color: ${(props) => props.theme.text.dark};
                  padding: 12px 14px;
                }
              }
            }
          }
        }

        .decrease-product {
          position: absolute;
          top: 5px;
          left: 10px;
        }

        .increase_product {
          position: absolute;
          top: 5px;
          right: 10px;
        }
      }
    }

    .highlightBox {
      width: 86%;
      background: ${(props) => props?.theme?.color?.white};
      border: 1px solid ${(props) => props?.theme?.color?.borderLight};
      border-radius: 8px;
      margin-bottom: 16px;

      .titleBar {
        width: 100%;
        padding: 16px;
        border-bottom: 1px solid ${(props) => props?.theme?.color?.borderLight};
        font-size: 18px;
        font-weight: 700;
      }
      .contentArea {
        width: 100%;
        padding: 16px;

        .listingItems {
          width: 100%;
          border-bottom: 1px solid ${(props) => props?.theme?.color?.borderLight};
          padding-bottom: 16px;
          margin-bottom: 16px;

          .listRow {
            width: 100%;
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 16px;
            display: flex;
            flex-direction: row;

            .listLabel {
              width: 30%;
              max-width: 140px;
              margin-right: 15px;
            }
            .listValue {
              color: ${(props) => props?.theme?.text?.medium};
            }

            &:last-child {
              margin-bottom: 0;
            }
          }

          &.noSpacing {
            padding-bottom: 0;
            margin-bottom: 0;
          }
        }

        .btnShowMore {
          color: ${(props) => props?.theme?.green?.dark};
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          display: inline-flex;
        }
      }
    }

    .pdpAdvtBox {
      width: 86%;
      overflow: hidden;
      margin-bottom: 16px;
      position: relative;

      > div {
        width: 100% !important;
      }
      img {
        max-width: 536px !important;
      }
    }

    .scrolledCartDetails {
      width: 100%;
      background: ${(props) => props?.theme?.color?.white};
      box-shadow: 0px -5px 40px ${(props) => props?.theme?.green?.dark}14;
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 2;

      .container {
        padding: 8px;
      }

      .dropdown {
        .dropdown-menu {
          min-width: 107px;
          max-height: 365px;
          overflow: auto;

          a {
            padding: 13px 16px 14px 16px;
            text-align: center;
          }
        }
      }

      .container {
        width: 100%;
        max-width: 906px;
        display: flex;
      }

      .scrolled-card-oos {
        background-color: ${(props) => props?.theme?.orange?.off};
        color: ${(props) => props?.theme?.colors?.secondary?.orange?.["700"]};
        height: 36px;
        font-family: Mulish;
        font-size: 14px;
        font-weight: 700;
        line-height: 20px;
        padding-right: 10px;
        border: 1px solid ${(props) => props?.theme?.grey?.iconBg};
        border-right: 0px;
        border-left: 0px;

        .content {
          justify-content: right;
          width: 100%;
          max-width: 906px;
          padding-right: 0px !important;
        }
      }

      .prodDetail {
        width: 100%;
        padding-right: 44px;
        border-right: 1px solid ${(props) => props?.theme?.color?.divider};
        display: flex;

        .prodThumb {
          width: 64px;
          min-width: 64px;
          height: 64px;
          border: 1px solid ${(props) => props?.theme?.color?.border};
          padding: 5px;
          border-radius: 4px;
          margin-right: 16px;

          img {
            width: 100%;
          }
        }

        .prodDesc {
          width: 100%;
          display: flex;
          flex-direction: column;

          .prodLabel {
            color: ${(props) => props?.theme?.green?.dark};
            font-size: 12px;
            font-weight: 700;
            margin-top: 3px;

            a {
              color: ${(props) => props?.theme?.green?.dark};
              text-decoration: none;

              &:hover {
                text-decoration: underline;
              }
            }
          }

          .prodInfo {
            font-size: 14px;
            line-height: 18px;
            font-weight: 600;
          }
        }
      }
      .cartDetail {
        width: 100%;
        padding-left: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .priceWrapper {
          margin-right: 33px;

          .price {
            font-weight: 700;
            font-size: 22px;
            line-height: 28px;
            color: ${(props) => props.theme.text.dark};
            white-space: nowrap;
            display: flex;
            align-items: center;
            direction: ltr;

            span {
              font-weight: 600;
              font-size: 15px;
              line-height: 19px;
              text-decoration-line: line-through;
              color: ${(props) => props.theme.text.medium};
              display: flex;
            }
          }

          .priceBreakup {
            font-size: 13px;
            color: ${(props) => props.theme.text.medium};
          }
        }

        .orderWrapper {
          .addToCartButtonWrapper {
            display: flex;

            .txtLoading {
              .dropdown {
                .dropdown-toggle {
                  &::after {
                    background-image: none;
                  }
                }
              }
            }

            .dropdown-toggle {
              color: ${(props) => props?.theme?.green?.dark};
              font-size: 20px;
              font-weight: 700;
              border-color: ${(props) => props?.theme?.green?.dark};
              padding: 12px 35px 12px 15px;
            }

            .isFloat {
              .btn {
                width: 224px !important;
                padding: 12px 20px;
                margin-right: 0;
                margin-left: 12px;
              }
            }

            .quantity-wrapper {
              width: 212px;
              background: ${(props) => props?.theme?.color?.white};
              position: relative;
              display: flex;

              .dropdown-toggle {
                border: 0;
                text-align: center;
                padding: 12px 15px;
                border: 1px solid ${(props) => props?.theme?.colors?.neutral?.darkBlue?.['50']};
                border-radius: 100px;
                .txtLoading {
                  font-size: 14px;
                }

                &::after {
                  right: 38%;
                }
              }

              .decrease-product {
                width: 42px;
                height: 42px;
                position: absolute;
                top: 4px;
                left: 3px;
                z-index: 1;
                cursor: pointer;
              }

              .increase_product {
                width: 42px;
                height: 42px;
                position: absolute;
                top: 4px;
                right: 2px;
                z-index: 1;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }

  .information-wrapper {
    padding: 24px;

    h2 {
      font-weight: 700;
      font-size: 15px;
      line-height: 19px;
      color: ${(props) => props.theme.text.dark};
    }

    .expand-collapse {
      font-weight: 700;
      font-size: 14px;
      line-height: 18px;
      color: ${(props) => props.theme.green.dark};
      margin-top: 0;
      cursor: pointer;
    }

    .overviewItems {
      width: 100%;
      margin-bottom: 16px;

      .detailsBox {
        width: 100%;
      }

      &:last-child {
        margin-bottom: 0;
        .detailsBox {
          ul {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .productDetailInfo {
    .order-wrapper {
      position: static;
    }
  }
  .pdpUpselling {
    margin-top: 40px;
  }

  @media (max-width: 820px) {
    .productDetailWrapper {
      .productCarousalWrapper {
        .slick-slider {
          .slick-list {
            max-height: 305px;
          }
        }
      }
      .productShowcaseWrapper {
        min-height: 300px;
        position: relative;
        z-index: 0;
        .productShowcase {
          padding-top: 10px;
        }
      }
      .productDetailInfo {
        .order-wrapper {
          &.order-wrapper-fixed{
            position: fixed;
            width: 100%;
            background: ${(props) => props.theme.color.white};
            padding: 16px;
            right: 0;
            bottom: -1px;
            z-index: 2;
            box-shadow: rgb(25 118 210 / 8%) 0 -5px 40px;
          }
        }
      }

      .order-wrapper {
        .ps-0 {
          padding-left: 12px !important;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .productDetailWrapper {
      .pdpAdvtBox {
        border-radius: 8px;
        max-width: 360px;
      }

      .productInfoWrapper {
        .uspBox {
          padding-top: 16px;

          .usp {
            .ic {
              max-width: 50px;
              max-height: 28px;
              margin-bottom: 10px;
            }

            &:last-child {
              .name {
                max-width: 100px;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 480px) {
    .productDetailWrapper {
      background: transparent;
      padding: 0;
      margin-bottom: 0;
      border: 0 solid ${(props) => props.theme.color.border};
      flex-direction: column;

      .productInfoWrapper {
        margin-left: 0%;
        width: 115%;
      }

      .productShowCase {
        padding-right: 0;
        position: relative;
        top: 0;
        bottom: auto;
      }

      .scrolledCartDetails {
        display: none;
      }

      .productDetailInfo {
        background: transparent;
        border: 0;
        padding: 0;

        .brandName {
          margin: 10px 0 10px 0;
        }

        .delivery-detail {
          margin-bottom: 0;
          background-color: ${(props) => props.theme.color.white};
        }

        .productName {
          font-size: 20px;
          margin-bottom: 0;
        }

        .priceContainer {
          margin-top: 16px;

          .priceWrapper {
            .price {
              font-size: 22px;
            }
          }
        }

        .order-wrapper {
          display: flex;
          align-items: center;

          .btn-outline-success,
          .btn-outline-danger,
          .btn-success {
            height: 44px;
            font-size: 16px;
            line-height: 16px;
            margin-right: 0;
            margin-left: auto;
            padding: 16px;
          }

          .btnGoToCart {
            white-space: nowrap;
            margin-right: 0;
            margin-left: 16px;
            padding: 10px 16px;
          }

          .priceWrapper {
            margin-right: 24px;

            .price {
              font-size: 22px;
              font-weight: 700;
              white-space: nowrap;

              span {
                color: ${(props) => props?.theme?.text?.medium};
                font-size: 16px;
                font-weight: 600;
                text-decoration: line-through;
                display: flex;
              }
            }

            .priceBreakup {
              font-size: 13px;
              color: ${(props) => props.theme.text.medium};
            }
          }

          .quantity-wrapper {
            .dropdown-wrapper.dropdown {
              height: 44px;

              .dropdown-toggle {
                height: 44px;
                font-size: 17px;
                line-height: 17px;

                .txtLoading {
                  font-size: 14px;
                }

                &:after {
                  right: 39% !important;
                }
              }
            }

            .decrease-product {
              width: 38px;
              height: 38px;
              top: 3px;
            }
            .increase_product {
              width: 38px;
              height: 38px;
              top: 3px;
            }
          }

          .addToCartButtonWrapper {
            .col-lg-12 {
              width: 100%;
            }
            .isFloat {
              width: inherit;
            }
            .btn-outline-success {
            }
            .quantity-wrapper-small {
              width: 25%;

              .dropdown-wrapper.dropdown {
                .dropdown-toggle {
                  height: 44px;
                  font-size: 16px;
                  line-height: 16px;

                  &::after {
                    right: 25% !important;
                  }
                }
              }
            }
          }
        }
      }

      .highlightBox {
        .contentArea {
          .listingItems {
            .listRow {
              .listLabel {
                width: 45%;
                max-width: 45%;
              }
            }
          }
        }
      }

      .pdpAdvtBox {
        max-width: 100%;
        > div {
          border-radius: 8px;
        }
      }

      .about-product {
        .titleBar {
          .title {
            margin: 24px 24px 24px 10px;
          }
        }
        .information-wrapper {
          padding: 24px 24px 24px 10px;
        }
      }

      .productShowcaseWrapper {
        padding: 0;

        .addToWishList {
          top: 10px;
          right: 10px;
        }
        .share-tost {
          top: 66px;
          right: 10px;
        }

        .slick-slide {
          padding: 5px 5px 25px 5px;
          position: relative;
        }

        .extraInfoForMobile {
          width: 392px;
          height: 336px;
          top: calc(50% - 2px);
          left: 50%;
          transform: translate(-50%, -50%);
        }

        .slick-cloned {
          .extraInfoForMobile {
            display: none;
          }
        }

        .slick-dots {
          bottom: 25px;
        }
      }
    }
    .productSliderMobileWrapper {
      position: relative;

      .slick-list {
        .slick-track {
          margin-top: 5px;
          .categoryItemBox {
            .item-wrapper {
              width: 100%;
              height: 300px;

              .product-thumb {
                width: 100%;
                height: 100%;
                background: ${(props) => props.theme.color.white};
                border-radius: 8px;
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;

                .videoThumb {
                  position: absolute !important;
                  right: 30% !important;
                  top: 32% !important;
                  @media (max-width: 480px) { 
                    right: 40% !important;
                    top: 35% !important;
                    width: 52px;
                    height: 52px;
                  }
                }

                img {
                  width: 150px;
                  height: auto;
                  margin: 0 auto;
                }
              }
            }
          }
        }
      }

      .slick-dots {
        bottom: 0;
      }
    }
  }

  @media (max-width: 380px) {
    .pageContent {
      .productDetailWrapper {
        .productDetailInfo {
          .order-wrapper {
            .priceWrapper {
              margin-right: 16px;

              .price {
                font-size: 14px !important;
              }
            }
          }
        }
      }
    }
  }

  .fbt-container {
    width: 86%;
    border-radius: 8px;
    border: 1px solid ${(props) => props?.theme?.color?.borderLight};
    background: ${(props) => props?.theme?.color?.white};
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;

    > .fbt-cart-btn.buy-button {
      padding: 10px 16px 16px;

      > .btn.btn-sm {
        font-size: 16px;
        padding: 18px 16px;
        font-weight: 700;
        line-height: 18px;
      }

      > .btn.btn-sm.fbtLoadingText {
        background: ${(props) => props?.theme?.color?.white} !important;
        color: ${(props) => props?.theme?.green?.dark} !important;
        border: 1px solid ${(props) => props?.theme?.green?.dark} !important;
        opacity: 0.9 !important;
        font-size: 16px;
        font-weight: 700;
      }

      .btn.disabled,
      .btn:disabled {
        background: ${(props) => props.theme.grey.grey4D} !important;
        border-color: ${(props) => props.theme.grey.grey4D} !important;
        color: ${(props) => props?.theme?.text?.medium} !important;
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
        opacity: 0.7;
      }
    }

    .fbt-title {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 0;
      padding: 20px 16px 16px;
      line-height: 23px;
      border-bottom: 1px solid ${(props) => props?.theme?.color?.borderLight};
    }

    .fbt-product-container {
      display: flex;
      flex-direction: row;
      align-items: inherit;
      padding: 20px 16px 10px 16px;
      overflow: auto;
      justify-content: center;
      width: 100%;

      .fbt-product {
        border-radius: 8px;
        border: 1px solid ${(props) => props?.theme?.color?.borderLight};
        background: ${(props) => props?.theme?.color?.white};
        display: flex;
        flex-direction: column;
        padding: 12px;
        position: relative;
        width: 31%;

        > a {
          text-decoration: none;
          color: inherit;
        }

        p {
          min-height: 42px;
          font-size: 15px;
          font-weight: 600;
          width: 102%;
          margin: 10px 0 6px;
          overflow: hidden;
          line-height: 19px;
          word-break: break-all;
        }

        .fbt_checkbox {
          position: absolute;
          top: 6px;
          left: 6px;
          z-index: 1;

          .form-check .form-check-input[type='checkbox'] {
            background-color: ${(props) => props?.theme?.color?.white};
            width: 24px;
            min-width: 24px;
            height: 24px;
          }
        }

        .fbt_checkbox + div {
          width: 100%;
          display: flex !important;
          justify-content: center;
          padding: 0 0 25px;
        }

        .price-label {
          display: flex;
          flex-direction: row;
          align-items: baseline;
          justify-content: space-between;
          flex-flow: wrap;

          > span {
            font-size: 16px;
            font-weight: 700;
            line-height: 20px;
            overflow-wrap: break-word;
            max-width: 100%;
          }

          > del {
            font-weight: 600;
            font-size: 12px;
            line-height: 20px;
            color: ${(props) => props?.theme?.text?.medium};
            overflow-wrap: break-word;
            max-width: 100%;
          }
        }
      }

      .fbt-product.failedToAdd {
        border: 1px solid ${(props) => props?.theme?.color?.red};
        background: ${(props) => props?.theme?.verification?.red.off};
      }

      .fbt-product-separator {
        font-size: 22px;
        font-weight: 700;
        margin: 5px;
        align-self: center;
      }
    }
  }

  @media (max-width: 480px) {
    .fbt-container {
      background: linear-gradient(
        180deg,
        ${(props) => props?.theme?.sectionBox?.gradientStart} 0%,
        ${(props) => props?.theme?.sectionBox?.gradientEnd} 100%
      );
      border: none;
      margin-bottom: 0;
      border-radius: 0;
      margin: 0 -16px;
      width: 100vw;
      padding: 0 16px;

      > .fbt-cart-btn.buy-button {
        padding: 16px 0;

        > .btn.btn-sm {
          font-size: 15px;
          padding: 15px 16px;
          line-height: 20px;
        }
      }

      .fbt-title {
        font-size: 18px;
        font-weight: 700;
        line-height: 23px;
        padding: 19px 0 16px;
        border-bottom: 0;
      }

      .fbt-product-container {
        padding: 0;
        justify-content: center;

        .fbt-product {
          padding: 8px;
          width: 30%;
          position: relative;

          .fbt_checkbox + div {
            padding: 0 0 15px;
          }

          p {
            font-size: 12px;
            font-weight: 600;
            line-height: 15px;
            width: 102%;
            min-height: 30px;
            margin: 0 0 4px;
          }

          .price-label {
            > del {
              font-weight: 600;
              font-size: 10px;
              line-height: 16px;
            }
            > span {
              font-size: 12px;
              font-weight: 700;
              line-height: 20px;
            }
          }
        }

        .fbt-product-separator {
          font-size: 20px;
          font-weight: 600;
          margin: 5px;
        }
      }
    }
  }
  @media (max-width: 380px) {
  }

  &.rtl {
    .productDetailWrapper {
      .productInfoWrapper {
        .priceContainer {
          .priceWrapper {
            .price {
              justify-content: end;
            }
          }
        }
      }
      .scrolledCartDetails {
        .prodDetail {
          padding-right: 0;
          padding-left: 44px;
          border: 0px;
          border-left: 1px solid ${(props) => props?.theme?.color?.divider};

          .prodThumb {
            margin-right: 0px;
            margin-left: 16px;
          }
        }
      }
      .highlightBox {
        .contentArea {
          .listingItems {
            .listRow {
              .listLabel {
                margin-right: 0px;
                margin-left: 15px;
              }
            }
          }
        }
      }
      .bankOffersBox {
        .offersBox {
          .description {
            strong {
              margin-right: 0px;
              margin-left: 5px;
            }
          }
        }
      }
      .productShowcaseWrapper {
        .badgeStack {
          right: 0;
          left: auto;
          padding: 10px 10px 0 0;
          .offer-tost {
            padding-left: 12px;
            padding-right: 6px;
            background: url(${IC_OFF_BOX_LEFT.src}) no-repeat;
            background-size: cover;
            background-position: left;
            justify-content: end;
            direction: ltr;
          }
        }
        .share-tost {
          left: 23px;
          right: auto;
          .filter {
            .filterBox {
              .box {
                .title {
                  .react-share__ShareButton {
                    > div {
                      margin: 0 0 0 10px !important;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    .information-wrapper {
      .overviewItems {
        .detailsBox {
          ul {
            padding-left: 0;
            padding-right: 2rem;
          }
        }
      }
    }
  }
`;
